    $('.new-testimonials').slick({
       dots: true,
  infinite: true,
  centerMode: true,
  centerPadding: '60px',
  slidesToShow: 5,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 589,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});
$(".flex-container-icons-slider").slick({
  slidesToShow: 1,
  autoplay: true,
  infinite: true,
  slidesToScroll: 1,
  prevArrow:
    '<svg class="slick-prev-no" xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none"> <circle cx="21.463" cy="21.463" r="21.463" fill="transparent"/> <path d="M18.0527 12.7192L26.7969 21.463L18.0527 30.2076" stroke="white" stroke-width="1.8" stroke-linecap="square" stroke-linejoin="round"/> </svg>',
  nextArrow:
    '<svg class="slick-next-no" xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none"> <circle cx="21.463" cy="21.463" r="21.463" transform="matrix(-1 0 0 1 42.926 0)" fill="transparent"/> <path d="M24.8735 12.7192L16.1293 21.463L24.8735 30.2076" stroke="white" stroke-width="1.8" stroke-linecap="square" stroke-linejoin="round"/> </svg>',
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick",
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
      },
    },
  ],
});
$(".trusted-images--pictures").slick({
  dots: false,
  infinite: true,
  slidesToShow: 5,
  centerMode: true,
  swipeToSlide: true,
  centerPadding: "0px",
  autoplay: true,
  asNavFor: ".trusted-brans-quote",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        infinite: true,
        arrows: false,
        centerMode: true,
        centerPadding: "100px",
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        arrows: false,
        infinite: true,
        centerMode: true,
        centerPadding: "100px",
      },
    },
  ],
});
$(".trusted-brans-quote").slick({
  arrows: false,
  dots: true,
  infinite: true,
  autoplay: true,
  fade: true,
  asNavFor: ".trusted-images--pictures",
});
$(".invertible-slider-outer").slick({
  arrows: true,
  dots: true,
  infinite: false,
  autoplay: false,
  adaptiveHeight: true,
  fade: true,
  appendDots: $(".dots-invertible"),
  prevArrow: $(".prev-invertible"),
  nextArrow: $(".next-invertible"),
  asNavFor: ".invertible-slider-numbers,.flex-container__inner-img",
});
$(".flex-container__inner-img").slick({
  arrows: false,
  dots: false,
  infinite: false,
  autoplay: false,
  adaptiveHeight: true,
  lazyLoad: "ondemand",
  fade: true,
  asNavFor: ".invertible-slider-outer,.invertible-slider-numbers",
});
$(".invertible-slider-numbers").slick({
  arrows: false,
  dots: false,
  infinite: false,
  autoplay: false,
  fade: true,
  asNavFor: ".invertible-slider-outer,.flex-container__inner-img",
});

$(document).ready(function () {
  $(".trusted-images--scroll").scrollLeft(250);
});

$(document).ready(function () {
  // Add custom code below this line
  setInterval(function time() {
    var d = new Date();
    var d1 = new Date();
    d.setHours(d1.getHours() + 9);
    var hours = 23 - d.getHours();
    var min = 60 - d.getMinutes();
    if ((min + "").length == 1) {
      min = "0" + min;
    }
    var sec = 60 - d.getSeconds();
    if ((sec + "").length == 1) {
      sec = "0" + sec;
    }
    $(".timer").html(hours + " hrs " + min + " mins");

    var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    var currentDateNew = new Date(new Date().getTime() + 0 * 60 * 60 * 1000);
    var day = currentDateNew.getDate();
    let dayN = "th";
    switch (day) {
      case 1:
        dayN = "st";
        break;
      case 2:
        dayN = "nd";
        break;
      case 3:
        dayN = "rd";
        break;
      default:
        dayN = "th";
    }
    var month = currentDate.getMonth() + 1;
    var year = currentDate.getFullYear();

    var days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    $(".date-product").html(
      days[currentDateNew.getDay()] +
        ", " +
        monthNames[currentDateNew.getMonth()]+
        " " +
        day
        
    );
  }, 1000);
});
